export default "__VITE_ASSET__C50bL2wm__"